import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import app from 'flarum/forum/app';
import Application from 'flarum/common/Application';
import { extend } from 'flarum/common/extend';
import TextEditor from 'flarum/common/components/TextEditor';
import styleSelectedText from 'flarum/common/utils/styleSelectedText';
import Component from 'flarum/common/Component';
import Icon from 'flarum/common/components/Icon';
import Tooltip from 'flarum/common/components/Tooltip';
import ColorPalettePopover, { DEFAULT_COLORS } from './components/ColorPalettePopover';
import AlertPickerPopover from './components/AlertPickerPopover';
import ImageAlignPopover from './components/ImageAlignPopover';
import MoreButtonsPopover from './components/MoreButtonsPopover';
function elOf(ctx) {
  var _ctx$attrs;
  return (ctx == null || (_ctx$attrs = ctx.attrs) == null || (_ctx$attrs = _ctx$attrs.composer) == null || (_ctx$attrs = _ctx$attrs.editor) == null ? void 0 : _ctx$attrs.el) || null;
}
function edOf(ctx) {
  var _ctx$attrs2;
  return (ctx == null || (_ctx$attrs2 = ctx.attrs) == null || (_ctx$attrs2 = _ctx$attrs2.composer) == null ? void 0 : _ctx$attrs2.editor) || null;
}
function on(key) {
  const v = app.forum.attribute(key);
  return v === undefined || v === null ? true : !!v;
}
function iconOf(name, fallback) {
  return app.forum.attribute("icon_".concat(name)) || fallback;
}
function findFoFTagAroundSelection(node) {
  const re = /\[upl-image-preview(?:(?!]).)*?\burl=(?:"[^"]+"|'[^']+'|[^\s\]]+)(?:(?!]).)*?](?:\s*\[\/upl-image-preview])?/i;
  const start = Math.max(0, node.selectionStart - 800);
  const end = Math.min(node.value.length, node.selectionEnd + 800);
  const slice = node.value.slice(start, end);
  const m = slice.match(re);
  if (!m) return null;
  const absStart = start + m.index;
  const absEnd = absStart + m[0].length;
  return {
    start: absStart,
    end: absEnd,
    text: m[0]
  };
}
function replaceRange(node, from, to, text) {
  node.setRangeText(text, from, to, 'end');
  node.dispatchEvent(new Event('input', {
    bubbles: true
  }));
}
function isTiptap(ed) {
  return !!(ed && ed.editor && typeof ed.editor.state !== 'undefined');
}
function getSelectedText(node, ed, start, end) {
  var _ed$editor$state$doc$, _ed$editor;
  if (node) return node.value.slice(start, end);
  return (_ed$editor$state$doc$ = ed == null || (_ed$editor = ed.editor) == null || (_ed$editor = _ed$editor.state) == null || (_ed$editor = _ed$editor.doc) == null ? void 0 : _ed$editor.textBetween(start, end, ' ')) != null ? _ed$editor$state$doc$ : '';
}
function replaceRangeUnified(node, ed, start, end, text) {
  if (node) {
    replaceRange(node, start, end, text);
  } else {
    ed.insertBetween(start, end, text, true);
  }
}
class MagicbbBtn extends Component {
  view() {
    const _this$attrs = this.attrs,
      title = _this$attrs.title,
      icon = _this$attrs.icon,
      onclick = _this$attrs.onclick;
    const button = m('button.Button.Button--icon.Button--link', {
      type: 'button',
      onclick
    }, m(Icon, {
      name: icon
    }));
    return m(Tooltip, {
      text: title
    }, button);
  }
}
app.initializers.add('forumaker-magicbb-buttons', () => {
  extend(TextEditor.prototype, 'toolbarItems', function (items) {
    const el = () => elOf(this);
    const editor = () => edOf(this);
    const grouped = on('bb_toolbar_group');
    const pool = [];
    const addBtn = function (key, icon, title, style, prio, defaultText) {
      if (defaultText === void 0) {
        defaultText = '';
      }
      const handler = e => {
        var _e$preventDefault;
        e == null || (_e$preventDefault = e.preventDefault) == null || _e$preventDefault.call(e);
        const node = el();
        const ed = editor();
        if (!ed) return;
        if (isTiptap(ed)) {
          const _ed$getSelectionRange = ed.getSelectionRange(),
            _ed$getSelectionRange2 = _slicedToArray(_ed$getSelectionRange, 2),
            start = _ed$getSelectionRange2[0],
            end = _ed$getSelectionRange2[1];
          const hasSelection = start !== end;
          const prefix = style.prefix || '';
          const suffix = style.suffix || '';
          if (!hasSelection) {
            ed.insertAtCursor(prefix + (defaultText || '') + suffix, true);
          } else {
            const selected = getSelectedText(node, ed, start, end);
            replaceRangeUnified(node, ed, start, end, prefix + selected + suffix);
          }
          return;
        }
        if (!node) return;
        const hasSelection = node.selectionStart !== node.selectionEnd;
        if (!hasSelection && defaultText) {
          ed.insertAtCursor((style.prefix || '') + defaultText + (style.suffix || ''));
        } else {
          styleSelectedText(node, style);
        }
      };
      pool.push({
        key,
        prio,
        title,
        icon,
        vnode: m(MagicbbBtn, {
          title,
          icon,
          onclick: handler
        }),
        asMenu: () => ({
          key,
          title,
          icon,
          onClick: handler
        })
      });
    };
    const addWrapBlockBtn = (key, icon, title, tag, prio) => {
      const handler = e => {
        var _e$preventDefault2;
        e == null || (_e$preventDefault2 = e.preventDefault) == null || _e$preventDefault2.call(e);
        const node = el();
        const ed = editor();
        if (!ed) return;
        const open = "[".concat(tag, "]");
        const close = "[/".concat(tag, "]");
        if (isTiptap(ed)) {
          const _ed$getSelectionRange3 = ed.getSelectionRange(),
            _ed$getSelectionRange4 = _slicedToArray(_ed$getSelectionRange3, 2),
            start = _ed$getSelectionRange4[0],
            end = _ed$getSelectionRange4[1];
          if (start === end) {
            ed.insertAtCursor(open + close, true);
          } else {
            const selected = getSelectedText(node, ed, start, end);
            replaceRangeUnified(node, ed, start, end, "".concat(open).concat(selected).concat(close));
          }
          return;
        }
        if (!node) return;
        const start = node.selectionStart;
        const end = node.selectionEnd;
        if (start === end) {
          const insert = open + close;
          node.setRangeText(insert, start, start, 'end');
          node.dispatchEvent(new Event('input', {
            bubbles: true
          }));
          const cursor = start + open.length;
          requestAnimationFrame(() => {
            node.focus();
            node.setSelectionRange(cursor, cursor);
          });
          return;
        }
        const selected = node.value.slice(start, end);
        const wrapped = "".concat(open).concat(selected).concat(close);
        replaceRange(node, start, end, wrapped);
      };
      pool.push({
        key,
        prio,
        title,
        icon,
        vnode: m(MagicbbBtn, {
          title,
          icon,
          onclick: handler
        }),
        asMenu: () => ({
          key,
          title,
          icon,
          onClick: handler
        })
      });
    };
    if (on('bb_center')) {
      addWrapBlockBtn('bb-center', iconOf('center', 'fas fa-align-center'), app.translator.trans('forumaker-magicbb.forum.composer.center_button'), 'center', 100);
    }
    if (on('bb_justify')) {
      addWrapBlockBtn('bb-justify', iconOf('justify', 'fas fa-align-justify'), app.translator.trans('forumaker-magicbb.forum.composer.justify_button'), 'justify', 99);
    }
    if (on('bb_color')) {
      const label = app.translator.trans('forumaker-magicbb.forum.composer.color_button');
      const colorIcon = iconOf('color', 'fas fa-palette');
      const handleColorSelect = hex => {
        const node = el();
        const ed = editor();
        if (!ed) return;
        const prefix = "[color=".concat(hex, "]");
        const suffix = '[/color]';
        if (isTiptap(ed)) {
          const _ed$getSelectionRange5 = ed.getSelectionRange(),
            _ed$getSelectionRange6 = _slicedToArray(_ed$getSelectionRange5, 2),
            start = _ed$getSelectionRange6[0],
            end = _ed$getSelectionRange6[1];
          if (start === end) {
            ed.insertAtCursor("".concat(prefix, "Heading").concat(suffix), true);
          } else {
            const selected = getSelectedText(node, ed, start, end);
            replaceRangeUnified(node, ed, start, end, "".concat(prefix).concat(selected).concat(suffix));
          }
          return;
        }
        if (!node) return;
        const hasSelection = node.selectionStart !== node.selectionEnd;
        if (!hasSelection) ed.insertAtCursor("".concat(prefix, "Heading").concat(suffix));else styleSelectedText(node, {
          prefix,
          suffix
        });
      };
      pool.push({
        key: 'bb-color',
        prio: 98,
        title: label,
        icon: colorIcon,
        vnode: m(ColorPalettePopover, {
          label,
          icon: colorIcon,
          colors: DEFAULT_COLORS,
          onSelect: handleColorSelect
        }),
        asMenuSub: () => ({
          key: 'bb-color',
          title: label,
          icon: colorIcon,
          renderSub: () => m(ColorPalettePopover, {
            label,
            icon: colorIcon,
            colors: DEFAULT_COLORS,
            onSelect: handleColorSelect
          })
        })
      });
    }
    if (on('bb_spoiler')) {
      addBtn('bb-spoiler', iconOf('spoiler', 'fas fa-layer-group'), app.translator.trans('forumaker-magicbb.forum.composer.spoiler_button'), {
        prefix: '[spoiler title=Heading]',
        suffix: '[/spoiler]'
      }, 97, 'Subtitle');
    }
    if (on('bb_table')) {
      const title = app.translator.trans('forumaker-magicbb.forum.composer.table_button');
      const tableIcon = iconOf('table', 'fas fa-table');
      const handler = e => {
        var _e$preventDefault3;
        e == null || (_e$preventDefault3 = e.preventDefault) == null || _e$preventDefault3.call(e);
        const ed = editor();
        if (!(ed != null && ed.insertAtCursor)) return;
        const tpl = '| Heading 1 | Heading 2 | Heading 3 |\n|---|---|---|\n| Cell 1 | Cell 2 | Cell 3 |\n| Cell 4 | Cell 5 | Cell 6 |';
        ed.insertAtCursor(tpl, true);
      };
      pool.push({
        key: 'bb-table',
        prio: 96,
        title,
        icon: tableIcon,
        vnode: m(MagicbbBtn, {
          title,
          icon: tableIcon,
          onclick: handler
        }),
        asMenu: () => ({
          key: 'bb-table',
          title,
          icon: tableIcon,
          onClick: handler
        })
      });
    }
    if (on('bb_info')) {
      const label = app.translator.trans('forumaker-magicbb.forum.composer.info_button');
      const infoIcon = iconOf('info', 'fas fa-info-circle');
      const handleAlertSelect = a => {
        const node = el();
        const ed = editor();
        if (!ed) return;
        const tag = a.key;
        const prefix = "[".concat(tag, " title=Heading font=").concat(a.font, " bg=").concat(a.bg, " border=").concat(a.border, "]");
        const suffix = "[/".concat(tag, "]");
        if (isTiptap(ed)) {
          const _ed$getSelectionRange7 = ed.getSelectionRange(),
            _ed$getSelectionRange8 = _slicedToArray(_ed$getSelectionRange7, 2),
            start = _ed$getSelectionRange8[0],
            end = _ed$getSelectionRange8[1];
          if (start === end) {
            ed.insertAtCursor("".concat(prefix, "Subtitle").concat(suffix), true);
          } else {
            const selected = getSelectedText(node, ed, start, end);
            replaceRangeUnified(node, ed, start, end, "".concat(prefix).concat(selected).concat(suffix));
          }
          return;
        }
        if (!node) return;
        const hasSelection = node.selectionStart !== node.selectionEnd;
        if (!hasSelection) ed.insertAtCursor("".concat(prefix, "Subtitle").concat(suffix));else styleSelectedText(node, {
          prefix,
          suffix
        });
      };
      pool.push({
        key: 'bb-info',
        prio: 95.5,
        title: label,
        icon: infoIcon,
        vnode: m(AlertPickerPopover, {
          label,
          icon: infoIcon,
          onSelect: handleAlertSelect
        }),
        asMenuSub: () => ({
          key: 'bb-info',
          title: label,
          icon: infoIcon,
          renderSub: () => m(AlertPickerPopover, {
            label,
            icon: infoIcon,
            onSelect: handleAlertSelect
          })
        })
      });
    }
    if (on('bb_audio')) {
      const title = app.translator.trans('forumaker-magicbb.forum.composer.audio_button');
      const audioIcon = iconOf('audio', 'fas fa-music');
      const handler = e => {
        var _e$preventDefault4;
        e == null || (_e$preventDefault4 = e.preventDefault) == null || _e$preventDefault4.call(e);
        const node = el();
        const ed = editor();
        if (!(ed != null && ed.insertAtCursor)) return;
        if (isTiptap(ed)) {
          const _ed$getSelectionRange9 = ed.getSelectionRange(),
            _ed$getSelectionRange0 = _slicedToArray(_ed$getSelectionRange9, 2),
            start = _ed$getSelectionRange0[0],
            end = _ed$getSelectionRange0[1];
          if (start !== end) {
            const selected = getSelectedText(node, ed, start, end).trim();
            replaceRangeUnified(node, ed, start, end, "[audio src=".concat(selected, "][/audio]"));
          } else {
            ed.insertAtCursor('[audio src=url][/audio]', true);
          }
          return;
        }
        if (!node) return;
        const hasSelection = node.selectionStart !== node.selectionEnd;
        if (hasSelection) {
          const selected = node.value.slice(node.selectionStart, node.selectionEnd).trim();
          replaceRange(node, node.selectionStart, node.selectionEnd, "[audio src=".concat(selected, "][/audio]"));
          return;
        }
        ed.insertAtCursor('[audio src=url][/audio]');
      };
      pool.push({
        key: 'bb-audio',
        prio: 95.25,
        title,
        icon: audioIcon,
        vnode: m(MagicbbBtn, {
          title,
          icon: audioIcon,
          onclick: handler
        }),
        asMenu: () => ({
          key: 'bb-audio',
          title,
          icon: audioIcon,
          onClick: handler
        })
      });
    }
    if (on('bb_image')) {
      const label = app.translator.trans('forumaker-magicbb.forum.composer.image_button');
      const imageIcon = iconOf('image', 'fas fa-image');
      const handleImagePick = align => {
        const node = el();
        const ed = editor();
        if (!ed) return;
        const wrap = tag => ({
          prefix: "[".concat(tag, "]"),
          suffix: "[/".concat(tag, "]")
        });
        const style = align === 'left' ? wrap('ileft') : align === 'right' ? wrap('iright') : wrap('icenter');
        if (isTiptap(ed)) {
          const _ed$getSelectionRange1 = ed.getSelectionRange(),
            _ed$getSelectionRange10 = _slicedToArray(_ed$getSelectionRange1, 2),
            start = _ed$getSelectionRange10[0],
            end = _ed$getSelectionRange10[1];
          if (start !== end) {
            const selected = getSelectedText(node, ed, start, end);
            replaceRangeUnified(node, ed, start, end, "".concat(style.prefix).concat(selected).concat(style.suffix));
          } else {
            ed.insertAtCursor("".concat(style.prefix, "upl-image-preview uuid").concat(style.suffix), true);
          }
          return;
        }
        if (!node) return;
        const hasSelection = node.selectionStart !== node.selectionEnd;
        if (hasSelection) {
          styleSelectedText(node, style);
          return;
        }
        const found = findFoFTagAroundSelection(node);
        if (found) {
          const replacement = "".concat(style.prefix).concat(found.text).concat(style.suffix);
          replaceRange(node, found.start, found.end, replacement);
          return;
        }
        ed.insertAtCursor("".concat(style.prefix, "upl-image-preview uuid").concat(style.suffix));
      };
      pool.push({
        key: 'bb-image',
        prio: 95,
        title: label,
        icon: imageIcon,
        vnode: m(ImageAlignPopover, {
          label,
          icon: imageIcon,
          onPick: handleImagePick
        }),
        asMenuSub: () => ({
          key: 'bb-image',
          title: label,
          icon: imageIcon,
          renderSub: () => m(ImageAlignPopover, {
            label,
            icon: imageIcon,
            onPick: handleImagePick
          })
        })
      });
    }
    if (on('bb_hide_login')) {
      addWrapBlockBtn('bb-hide-login', iconOf('hide_login', 'fas fa-sign-in-alt'), app.translator.trans('forumaker-magicbb.forum.composer.hide_login_button'), 'login', 94);
    }
    if (on('bb_hide_reply')) {
      addWrapBlockBtn('bb-hide-reply', iconOf('hide_reply', 'fas fa-reply'), app.translator.trans('forumaker-magicbb.forum.composer.hide_reply_button'), 'reply', 93);
    }
    if (on('bb_hide_like')) {
      addWrapBlockBtn('bb-hide-like', iconOf('hide_like', 'fas fa-heart'), app.translator.trans('forumaker-magicbb.forum.composer.hide_like_button'), 'like', 92);
    }
    if (on('bb_anchor')) {
      const anchorTitle = app.translator.trans('forumaker-magicbb.forum.composer.anchor_button');
      const anchorIcon = iconOf('anchor', 'fas fa-anchor');
      const anchorHandler = e => {
        var _e$preventDefault5;
        e == null || (_e$preventDefault5 = e.preventDefault) == null || _e$preventDefault5.call(e);
        const node = el();
        const ed = editor();
        if (!(ed != null && ed.insertAtCursor)) return;
        if (isTiptap(ed)) {
          ed.insertAtCursor('[anchor=name]', true);
        } else {
          if (!node) return;
          ed.insertAtCursor('[anchor=name]');
        }
      };
      pool.push({
        key: 'bb-anchor',
        prio: 91,
        title: anchorTitle,
        icon: anchorIcon,
        vnode: m(MagicbbBtn, {
          title: anchorTitle,
          icon: anchorIcon,
          onclick: anchorHandler
        }),
        asMenu: () => ({
          key: 'bb-anchor',
          title: anchorTitle,
          icon: anchorIcon,
          onClick: anchorHandler
        })
      });
      addBtn('bb-jump', iconOf('jump', 'fas fa-hashtag'), app.translator.trans('forumaker-magicbb.forum.composer.jump_button'), {
        prefix: '[jump=name]',
        suffix: '[/jump]'
      }, 90, 'Link text');
    }
    pool.sort((a, b) => b.prio - a.prio);
    if (grouped) {
      const menuItems = pool.map(p => 'asMenuSub' in p ? p.asMenuSub() : p.asMenu());
      const moreIcon = iconOf('more', 'fas fa-wand-sparkles');
      items.add('bb-more', m(MoreButtonsPopover, {
        items: menuItems,
        label: app.translator.trans('forumaker-magicbb.forum.composer.more_button'),
        icon: moreIcon
      }), 120);
    } else {
      pool.forEach(b => items.add(b.key, b.vnode, b.prio));
    }
  });
});
app.initializers.add('forumaker-magicbb-live-reveal', () => {
  function refetchPost(id) {
    app.store.find('posts', id).then(() => m.redraw()).catch(() => {});
  }
  extend(Application.prototype, 'request', function (result, options) {
    var _options$method, _options$url;
    const method = ((_options$method = options == null ? void 0 : options.method) != null ? _options$method : 'GET').toUpperCase();
    const url = (_options$url = options == null ? void 0 : options.url) != null ? _options$url : '';
    if (method === 'GET') return;
    const postMatch = url.match(/\/posts\/(\d+)/);
    if (postMatch) {
      var _result$then;
      const id = postMatch[1];
      result == null || (_result$then = result.then) == null || _result$then.call(result, () => {
        if (document.querySelector("[data-id=\"".concat(id, "\"] .bb-hide"))) {
          setTimeout(() => refetchPost(id), 250);
        }
      });
    }
    if (method === 'POST' && /\/posts$/.test(url)) {
      var _result$then2;
      result == null || (_result$then2 = result.then) == null || _result$then2.call(result, () => {
        setTimeout(() => {
          document.querySelectorAll('[data-id] .bb-hide--reply').forEach(el => {
            var _el$closest;
            const id = (_el$closest = el.closest('[data-id]')) == null ? void 0 : _el$closest.getAttribute('data-id');
            if (id) refetchPost(id);
          });
        }, 800);
      });
    }
  });
});
app.initializers.add('forumaker-magicbb-anchor-scroll', () => {
  document.addEventListener('click', e => {
    var _link$getAttribute;
    const link = e.target.closest('a.bb-jump');
    if (!link) return;
    const href = (_link$getAttribute = link.getAttribute('href')) != null ? _link$getAttribute : '';
    if (!href.startsWith('#magicbb-')) return;
    e.preventDefault();
    e.stopPropagation();
    const anchor = document.getElementById(href.slice(1));
    if (anchor) {
      anchor.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  }, true);
});